import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { useState, useEffect, useContext } from "react";
import { Tabs, Tab } from "@mui/material";
import { FiPlus } from "react-icons/fi";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import DriverTable from "components/driver/DriverTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import DriverServices from "services/DriverServices";
import DriverDrawer from "components/drawer/DriverDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import { FiRefreshCcw } from "react-icons/fi";

const Driver = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const [drivers, setDrivers] = useState([]);
  const [status, setStatus] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0); // Tab state
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [exportingData, setExportingData] = useState([]);

  const { driverRef, dataTable, serviceData, handleSubmitDriver, currentPage } =
    useFilter(drivers, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  // Fetch data based on selected tab
  useEffect(() => {
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        let status;

        switch (tab) {
          case 0:
            status = 2; // Unverified
            break;
          case 1:
            status = 1; // Active
            break;
          case 2:
            status = 3; // Blocked
            break;
          case 3:
            status = 4; // Rejected
            break;
          default:
            status = 1;
        }

        const response = await DriverServices.getDriverList(status);
        // console.log("driver data", response);

        const updatedData =
          response?.data?.map(
            ({
              id,
              vendor_id,
              vendor_name,
              driver_name,
              driver_contact_no,
              added_date,
              city,
              status,
              ...rest
            }) => ({
              id,
              vendor_id,
              vendor_name,
              driver_name,
              driver_contact_no,
              added_date,
              city,
              status,
              ...rest,
            })
          ) || [];

        setDrivers(updatedData);
        setStatus(response?.status);

        const finalData = response?.data?.map((item, index) => {
          // console.log(item);
          return {
            "SI.No": index + 1,
            "Vendor Name": item.vendor_name,
            "Driver Name": item.driver_name,
            "Contact No": item.driver_contact_no,
            "Added Date": item.added_date,
            City: item.city,
            Status: item.status === 0 ? "Active" : "InActive",
          };
        });
        // console.log("excell driverfinal data", finalData);
        setExportingData(finalData);
      } catch (error) {
        setError(true);
        //	console.error('Error fetching drivers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDrivers();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "driver list" && perm.view === 1
    );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "driver list" && perm.delete === 1
    );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "driver list" && perm.edit === 1
    );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "driver list" && perm.add === 1
    );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "driver list" && perm.export === 1
    );

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  const getTabName = () => {
    if (tab === 0) return "Unverified";
    if (tab === 1) return "Active";
    if (tab === 2) return "Blocked";
    if (tab === 3) return "Rejected";
    return "";
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={null} title="" />
          <MainDrawer>
            <DriverDrawer id={null} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex gap-6 items-center">
                <Input
                  ref={driverRef}
                  className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                  type="search"
                  name="search"
                  autoComplete="off"
                  placeholder="Quick Search"
                  onChange={handleSubmitDriver}
                />

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Driver
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    title="Driver"
                    exportDataXlsx={exportingData}
                    fileNames={`Driver_${getTabName()}`}
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unverified" // First tab is now Unverified
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Active" // Second tab is now Active
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Blocked"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Rejected"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Vendor Name</TableCell>
                        <TableCell>Driver Name</TableCell>
                        <TableCell>Contact No</TableCell>
                        {(tab === 1 || tab === 2) && (
                          <TableCell>Status for Block</TableCell>
                        )}
                        {tab === 3 && <TableCell>Cancelled Status</TableCell>}
                        {(tab === 3 || tab === 2) && (
                          <TableCell>Reason</TableCell>
                        )}
                        {tab === 0 && <TableCell>Status</TableCell>}
                        {/* {tab === 0 && <TableCell>Request Type</TableCell>} */}
                        {tab === 0 && <TableCell>Requested Changes</TableCell>}
                        {tab !== 0 && <TableCell>Rating</TableCell>}
                        <TableCell className="text-center">Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <DriverTable
                      driver={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <NotFound title="There are no Drivers." />
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Driver;
